import {isString} from "lodash";
import ChartInteractions from "./lib/chart";
import ChartOptions from "./config/ChartOptions";
import {Chart} from "../../node_modules/chart.js/dist/Chart.min"

export default class ChartBox {

  init() {
    this.initializeChart()
    this.setWrapperHeight()
  }

  initializeChart() {
    window.LineChart = new Chart(
      this.canvas.getContext('2d'),
      ChartOptions([])
    )
  }

  get store() {
    return this.$store.configurator
  }

  get canvas() {
    return this.$refs.chart
  }

  get display() {
    return this.store.chartDisplay
  }

  set display(name) {
    this.store.chartDisplay = name
  }

  toggleDisplay(display) {

    if (isString(display)) {
      this.display = display
    } else {

      this.display !== 'cooling_power'
        ? this.display = 'cooling_power'
        : this.display = 'pressure_loss'
    }

    ChartInteractions.updateChartData()

  }

  setWrapperHeight() {
    this.$refs.wrapper.style.height = this.$refs.chart.offsetHeight + 'px'
  }
}

